import * as i0 from '@angular/core';
import * as i1 from './firebase.module';
export const FirebaseModuleNgFactory:i0.NgModuleFactory<i1.FirebaseModule> = (null as any);
var _decl0_0:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_1:i0.ElementRef = (<any>(null as any));
